import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { alias } from '@ember/object/computed';
export default ProtoBaseModel.extend({
  enablePasscode: attr(Boolean),
  // Alias from TAPI security flag to standard security flag
  passcodesEnabled: alias('enablePasscode')
});